import Header from "../component/Header";
import { useEffect, useState } from "react";
import { Box, IconButton, List, ListItem, ListItemButton, ListItemText } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import AlertsDialog from "../component/AlertsDialog";
import AlertsSnackbar from "../component/AlertsSnackbar";
import { useCookies } from "react-cookie";
import { authWithdraw } from "../services/api/api";
import MyBottomNavigation from "../component/MyBottomNavigation";
import { useTranslation } from "react-i18next";

function Setting(): JSX.Element {
  const { t } = useTranslation();
  const [cookies, setCookie, removeCookie] = useCookies(['recotech_mapapps_token']);
  const [isWaitingResponse, setIsWaitingResponse] = useState<boolean>(false);

  const navigate = useNavigate();

  //SnackBarの設定
  const [openSnackbar, setOpenSnackbar] = useState<boolean>(false);
  const [alertsMessage, setAlertsMessage] = useState<string>("");
  const [severity, setSeverity] = useState< "error" | "success" >("error");

  const [openDialog, setOpenDialog] = useState<boolean>(false);

  useEffect(() => {
    if (!cookies.recotech_mapapps_token) navigate("/");
  }, []);

  const handleAgreeClick = (async () => {
    const res = await authWithdraw(cookies.recotech_mapapps_token,setAlertsMessage,setSeverity,setOpenSnackbar)
    if(res){
      //アカウント削除後の処理
      removeCookie("recotech_mapapps_token")
    }else{
      //アカウント削除失敗の処理
    }      
    setOpenDialog(false)
  })
  return (
    <>
      <AlertsSnackbar
        openSnackbar={openSnackbar}
        setOpenSnackbar={setOpenSnackbar}
        vertical={"top"}
        severity={severity}
        message={alertsMessage}
      />
      <AlertsDialog
        openDialog={openDialog}
        setOpenDialog={setOpenDialog}
        handleAgreeClick={()=>handleAgreeClick()}
        dialogTitle={t("pages.setting.deleteAccount")}
        dialogMessage={t("pages.setting.deleteWarning")}
        isWaitingResponse={isWaitingResponse}
      />
      <Header/>
        <Box
          sx={{ p: 3 }}
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
        >
          <Box
              sx={{ width: "85vw", height: "100vh", bgcolor: 'background.paper' }}
          >
            <List>
               <ListItem disablePadding
                  secondaryAction={
                    <IconButton edge="end" aria-label="comments">
                      <ArrowForwardIosIcon />
                    </IconButton>
                  }
                >
                <ListItemButton
                    onClick={ () => {
                      navigate('/howto')
                    }}
                >
                  <ListItemText primary={t("pages.setting.howToUse")} />
                </ListItemButton>
              </ListItem>
               <ListItem disablePadding
                  secondaryAction={
                    <IconButton edge="end" aria-label="comments">
                      <ArrowForwardIosIcon />
                    </IconButton>
                  }
                >
                <ListItemButton
                    onClick={ () => {
                      navigate('/addplace')
                    }}
                >
                  <ListItemText primary={t("pages.setting.registerPoint")} />
                </ListItemButton>
                </ListItem>
                <ListItem disablePadding
                  secondaryAction={
                    <IconButton edge="end" aria-label="comments">
                      <ArrowForwardIosIcon />
                    </IconButton>
                  }
                >
                <ListItemButton
                    onClick={ () => {
                      navigate('/myarea')
                    }}
                >
                  <ListItemText primary={t("pages.setting.myArea")} />
                </ListItemButton>
                </ListItem>
                <ListItem disablePadding
                  secondaryAction={
                    <IconButton edge="end" aria-label="comments">
                      <ArrowForwardIosIcon />
                    </IconButton>
                  }
                >
                <ListItemButton
                    onClick={ () => {
                      navigate('/addmyarea')
                    }}
                >
                  <ListItemText primary={t("pages.setting.changeMyArea")} />
                </ListItemButton>
                </ListItem>
                <ListItem disablePadding
                  secondaryAction={
                    <IconButton edge="end" aria-label="comments">
                      <ArrowForwardIosIcon />
                    </IconButton>
                  }
                >
                <ListItemButton
                    onClick={ () => {
                      navigate('/terms')
                    }}
                >
                  <ListItemText primary={t("pages.setting.terms")} />
                </ListItemButton>
                </ListItem>
                <ListItem disablePadding
                  secondaryAction={
                    <IconButton edge="end" aria-label="comments">
                      <ArrowForwardIosIcon />
                    </IconButton>
                  }
                >
                <ListItemButton
                    onClick={ () => {
                      navigate('/privacy')
                    }}
                >
                  <ListItemText primary={t("pages.setting.privacyPolicy")} />
                </ListItemButton>
                </ListItem>
                <ListItem disablePadding
                  secondaryAction={
                    <IconButton edge="end" aria-label="comments">
                      <ArrowForwardIosIcon />
                    </IconButton>
                  }
                >
                <ListItemButton
                    onClick={() => {
                      window.location.href = 'mailto:info@recotech.co.jp';
                    }}
                >
                  <ListItemText primary={t("pages.setting.contact")} />
                </ListItemButton>
                </ListItem>
                <ListItem disablePadding
                  secondaryAction={
                    <IconButton edge="end" aria-label="comments">
                      <ArrowForwardIosIcon />
                    </IconButton>
                  }
                >
                <ListItemButton
                    onClick={ () => {
                      navigate('/login')
                    }}
                >
                  <ListItemText primary={(cookies.recotech_mapapps_token) ? t("pages.setting.logout") : t("pages.setting.login")} />
                </ListItemButton>
                </ListItem>
                <ListItem disablePadding
                  secondaryAction={
                    <IconButton edge="end" aria-label="comments">
                      <ArrowForwardIosIcon />
                    </IconButton>
                  }
                >
                <ListItemButton
                    onClick={ () => {
                      setOpenDialog(true)
                    }}
                >
                  <ListItemText primary={t("pages.setting.deleteAccount2")} />
                </ListItemButton>
                </ListItem>
            </List>
          </Box>
        </Box>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          width="100%"
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
          }}
        >
          <MyBottomNavigation />
        </Box>
    </>
  );
};
export default Setting;
